"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeFeatures_en_us = void 0;
function backofficeFeatures_en_us() {
    return {
        "backoffice.features.checkin.configuration.apps": "Check-In Apps",
        "backoffice.features.workflow.configuration.amount": "Workflows",
        "backoffice.features.devices.configuration.amount": "Devices",
        "backoffice.features.forms.configuration.amount": "Forms",
        "backoffice.features.files.configuration.space": "Storage for Files",
        "backoffice.features.files.configuration.space_suffix": "GB",
        "backoffice.features.email.configuration.type": "E-Mail Service",
        "backoffice.features.email.configuration.type_values.custom": "Customizable",
        "backoffice.features.email.configuration.type_values.standard": "Simple",
        "backoffice.features.i18n.configuration.locales": "Amount of Languages",
        "backoffice.features.custom.configuration.datastorage": "Custom Data Entries",
        "backoffice.features.custom.configuration.datatypes": "Custom Data Types",
        "backoffice.features.users.configuration.amount": "Customers",
        "backoffice.features.products.configuration.amount": "Products",
        "backoffice.features.custombackoffices.configuration.amount": "Custom Backoffices",
        "backoffice.features.cms.configuration.amount": "Cms",
        "backoffice.features.cms.configuration.pages": "CMS Pages",
        "backoffice.features.configuration.configuration.amount": "Configuration",
        "backoffice.features.configuration.configuration.enabled": "Configuration",
        "backoffice.features.optin.configuration.amount": "Optin",
        "backoffice.features.optin.configuration.enabled": "Optin",
        "backoffice.features.impex.configuration.amount": "Impex",
        "backoffice.features.impex.configuration.enabled": "Impex",
        "backoffice.features.internationalization.configuration.amount": "Internationalization",
        "backoffice.features.internationalization.configuration.locales": "Locales"
    };
}
exports.backofficeFeatures_en_us = backofficeFeatures_en_us;
